import { forumEnvelope, forumError, invalidResponse, staleResponse } from './forumErrors';
import { forumId } from '../models/forumMappers';

export function reactionVotes(raw) {
  if (!raw || ![raw.positive, raw.negative].every(n => Number.isSafeInteger(n) && n >= 0) || ![-1, 1, null].includes(raw.own)) throw invalidResponse();
  return { positive: raw.positive, negative: raw.negative, own: raw.own };
}

// Desired state, never a toggle request. Coalesce rapid clicks per entity; no
// automatic POST retry. The page reconciles only after a confirmed response.
export function createForumReactionRepository({ http, getIdentity, invalidate = () => {} }) {
  const flights = new Map(), identity = () => JSON.stringify(getIdentity() || {});
  function send(kind, target, payload, map, tags) {
    if (!forumId((getIdentity() || {}).uid)) return Promise.reject(staleResponse());
    const owner = identity(), key = owner + ':' + kind + ':' + target;
    if (flights.has(key)) return flights.get(key);
    const current = () => { if (owner !== identity()) throw staleResponse(); };
    const request = Promise.resolve().then(() => { current(); return http.post('/forum/api/v2/' + kind, payload); }).then(response => {
      current(); const result = map(forumEnvelope(response.data).data);
      try { invalidate(tags); } catch (_) { /* The server's confirmation remains authoritative. */ }
      return result;
    }).catch(error => { current(); throw forumError(error); }).finally(() => { if (flights.get(key) === request) flights.delete(key); });
    flights.set(key, request); return request;
  }
  return {
    vote(threadId, post, value) {
      const nid = forumId(threadId), id = forumId(post && post.id), type = post && post.type === 'topic' ? 'node' : post && post.type === 'comment' ? 'comment' : null;
      if (!nid || !id || !type || (type === 'node' && id !== nid) || ![-1, 1, null].includes(value)) return Promise.reject(invalidResponse());
      return send('vote', type + ':' + id, { entity_type: type, entity_id: id, value }, data => {
        if (forumId(data.entity_id) !== id || data.entity_type !== type) throw invalidResponse();
        return reactionVotes(data.votes);
      }, ['thread:' + nid]);
    },
    favorite(threadId, value) {
      const id = forumId(threadId);
      if (!id || typeof value !== 'boolean') return Promise.reject(invalidResponse());
      return send('favorite', id, { thread_id: id, favorite: value }, data => {
        if (forumId(data.thread_id) !== id || typeof data.favorite !== 'boolean') throw invalidResponse();
        return data.favorite;
      }, ['thread:' + id, 'activity']);
    }
  };
}
